import { render, staticRenderFns } from "./StudentDashboardPage.vue?vue&type=template&id=0e64e068&"
import script from "./StudentDashboardPage.vue?vue&type=script&lang=ts&"
export * from "./StudentDashboardPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e64e068')) {
      api.createRecord('0e64e068', component.options)
    } else {
      api.reload('0e64e068', component.options)
    }
    module.hot.accept("./StudentDashboardPage.vue?vue&type=template&id=0e64e068&", function () {
      api.rerender('0e64e068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/340th/Student/StudentDashboardPage.vue"
export default component.exports